"use client";

import React from "react";
import {
  FileText,
  File,
  Image as ImageIcon,
  Video,
  Music,
  Presentation,
  Sheet,
} from "lucide-react";

export function getFileTypeLabel(mimeType: string): string {
  if (mimeType.includes("document")) return "Google Doc";
  if (mimeType.includes("spreadsheet")) return "Google Sheets";
  if (mimeType.includes("presentation")) return "Google Slides";
  if (mimeType.includes("pdf")) return "PDF Document";
  if (mimeType.startsWith("image/")) return "Image";
  if (mimeType.startsWith("video/")) return "Video";
  if (mimeType.startsWith("audio/")) return "Audio";
  if (mimeType.includes("zip") || mimeType.includes("archive")) return "Archive";
  if (mimeType.startsWith("text/")) return "Text File";
  return "File";
}

export function getFileTypeIcon(mimeType: string): React.ReactNode {
  if (mimeType.includes("document")) return <FileText className="h-5 w-5 text-blue-600" />;
  if (mimeType.includes("spreadsheet")) return <Sheet className="h-5 w-5 text-green-600" />;
  if (mimeType.includes("presentation")) return <Presentation className="h-5 w-5 text-orange-500" />;
  if (mimeType.startsWith("image/")) return <ImageIcon className="h-5 w-5 text-green-500" />;
  if (mimeType.startsWith("video/")) return <Video className="h-5 w-5 text-purple-500" />;
  if (mimeType.startsWith("audio/")) return <Music className="h-5 w-5 text-pink-500" />;
  if (mimeType === "application/pdf") return <FileText className="h-5 w-5 text-red-500" />;
  return <File className="h-5 w-5 text-gray-500" />;
}

interface PreviewableFile {
  mimeType: string;
  isGoogleDoc: boolean;
  webViewLink?: string;
  size?: string;
}

export function canPreviewFile(file: PreviewableFile): boolean {
  if (file.isGoogleDoc && file.webViewLink) return true;
  if (file.mimeType.startsWith("image/")) return true;
  if (file.mimeType === "application/pdf" && file.webViewLink) return true;
  if (file.mimeType.startsWith("text/") && file.size && parseInt(file.size) < 1024 * 1024) return true;
  return false;
}
